import { render } from "./AppProdottiGruppo.vue?vue&type=template&id=52765c30&scoped=true"
import script from "./AppProdottiGruppo.vue?vue&type=script&lang=js"
export * from "./AppProdottiGruppo.vue?vue&type=script&lang=js"

import "./AppProdottiGruppo.vue?vue&type=style&index=0&id=52765c30&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52765c30"]])

export default __exports__